import React, {Fragment} from "react"
import { Link } from "react-router-dom"

const TagContent = [
    {
      tag: "Solución Web",
      routerPath: "/blog-details" 
    },
    {
      tag: "Solución Web",
      routerPath: "/blog-details" 
    },
    {
      tag: "Soporte Tecnológico",
      routerPath: "/blog-details" 
    },
    {
      tag: "Diseño UI/UX",
      routerPath: "/blog-details" 
    },
    {
      tag: "Desarrollo",
      routerPath: "/blog-details" 
    },
    {
      tag: "HTML",
      routerPath: "/blog-details" 
    },
]

const CategoryTag = () => {
    return (
        <Fragment>
            <div className="tag-list">
                {TagContent.map((val, i)=>(
                    <Link key={i} to={val.routerPath}>{val.tag}</Link>
                ))}
            </div>
        </Fragment>
    )
}

export default CategoryTag